import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';

declare var jQuery: any;


@Component({
  selector: 'ch-member-export-modal-email-dialog',
  templateUrl: './member-export-modal-email-dialog.component.html',
  styleUrls: ['./member-export-modal-email-dialog.component.css'],
})
export class MemberExportModalEmailDialogComponent {
  @Input() public show: boolean;
  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  @Output() public onExport: EventEmitter<any> = new EventEmitter();
  @ViewChild('modal') private modal;
  public loading: boolean;
  private change: boolean;

  ngOnChanges() {
    if (this.show) {
      this.change = true;
    }
  }

  ngAfterViewChecked() {
    if (this.change) {
      jQuery(this.modal.nativeElement)
        .modal({
          backdrop: false,
        })
        .on('hidden.bs.modal', e => {
          this.onClose.emit(e);
        });

      this.change = false;
    }
  }

  public submitRecipientEmail(form: NgForm) {
    if (!form.valid) {
      return;
    }
    const data = {
      email: form.value.email,
    };

    this.onExport.emit(data);
    this.closeDialog();
  }

  private closeDialog() {
    jQuery(this.modal.nativeElement).modal('hide');
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/member-export-modal-email-dialog/member-export-modal-email-dialog.component.ts